import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasChanges", "parentSet", "skills", "skillOrderMode", "onChangeSkillOrderMode", "onReorderSkills", "onChangeSkills"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import filterObject from 'utils/filterObject';
import createLocation from 'utils/createLocation';
import toArray from 'utils/toArray';
import { SKILL_ROUTES } from 'utils/routes';
import FormField from 'components/FormField';
import FormStack from 'components/FormStack';
import Button from 'components/Button';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedListItem from 'components/ShadedListItem';
import SortableStack, { DragHandle } from 'components/SortableStack';
import Stack from 'components/Stack';
import UnsavedChangesModal from 'screens/UnsavedChangesModal';
import SkillPickerModal from 'screens/SkillPickerModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function SkillsField(_ref) {
  var hasChanges = _ref.hasChanges,
    parentSet = _ref.parentSet,
    skills = _ref.skills,
    skillOrderMode = _ref.skillOrderMode,
    onChangeSkillOrderMode = _ref.onChangeSkillOrderMode,
    onReorderSkills = _ref.onReorderSkills,
    onChangeSkills = _ref.onChangeSkills,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pendingSkillId = _useState2[0],
    setPendingSkillId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasSkillPickerModal = _useState4[0],
    setHasSkillPickerModal = _useState4[1];
  function navigateToSkill(skillId) {
    navigate(createLocation(SKILL_ROUTES.root, filterObject({
      tab: 'skills',
      skillsSelection: [skillId],
      parentSetId: parentSet === null || parentSet === void 0 ? void 0 : parentSet.id,
      parentSetName: parentSet === null || parentSet === void 0 ? void 0 : parentSet.name
    })));
  }
  function onEditSkill(skillId) {
    if (hasChanges) {
      setPendingSkillId(skillId);
    } else {
      navigateToSkill(skillId);
    }
  }
  function onDiscardChanges() {
    if (pendingSkillId) {
      navigateToSkill(pendingSkillId);
      setPendingSkillId(null);
    }
  }
  function onRemoveSkill(skillId) {
    var skillsToRemove = skills.filter(function (item) {
      return item.id === skillId;
    });
    if (skillsToRemove) {
      onChangeSkills({
        toRemove: skillsToRemove
      });
    }
  }
  function onSubmitSkills(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    onChangeSkills({
      toAdd: toArray(toAdd),
      toRemove: toArray(toRemove)
    });
    setHasSkillPickerModal(false);
  }
  function onDragEnd(_ref3) {
    var source = _ref3.source,
      destination = _ref3.destination;
    if (skillOrderMode !== 'custom' || !destination || source.index === destination.index) {
      return;
    }
    var reordered = _toConsumableArray(skills);
    var _reordered$splice = reordered.splice(source.index, 1),
      _reordered$splice2 = _slicedToArray(_reordered$splice, 1),
      moved = _reordered$splice2[0];
    reordered.splice(destination.index, 0, moved);
    onReorderSkills(reordered.map(function (skill) {
      return skill.id;
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FormStack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(FormField, {
        as: "fieldset",
        label: t('form_skill_order'),
        description: t('form_skill_order_hint'),
        descriptionType: "tooltip",
        horizontalLabelOffset: 0,
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          children: [/*#__PURE__*/_jsx(RadioButtonOption, {
            id: "skill_order_alphabetical",
            name: "skill_order",
            label: t('property_alphabetical'),
            value: "alphabetical",
            checked: skillOrderMode === 'alphabetical',
            onChange: function onChange() {
              return onChangeSkillOrderMode('alphabetical');
            }
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            id: "skill_order_custom",
            name: "skill_order",
            label: t('property_custom'),
            value: "custom",
            checked: skillOrderMode === 'custom',
            onChange: function onChange() {
              return onChangeSkillOrderMode('custom');
            }
          })]
        })
      }), /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
        as: "fieldset",
        required: true,
        label: "".concat(t('content_type_skill_plural'), " *"),
        alert: skills.length === 0 ? t('form_alert_required_field') : undefined,
        horizontalLabelOffset: 0
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          children: [/*#__PURE__*/_jsx(SortableStack, {
            spacing: "xs",
            items: skills,
            getItemId: function getItemId(item) {
              return String(item.id);
            },
            onDragEnd: onDragEnd,
            isDragDisabled: skillOrderMode !== 'custom',
            itemRenderer: function itemRenderer(_ref4) {
              var item = _ref4.item,
                dragHandleProps = _ref4.dragHandleProps;
              return /*#__PURE__*/_jsx(ShadedListItem, {
                id: item.id,
                title: item.name,
                dragHandle: skillOrderMode === 'custom' ? /*#__PURE__*/_jsx(DragHandle, _objectSpread(_objectSpread({}, dragHandleProps), {}, {
                  "aria-label": t('actions_reorder_name', {
                    name: item.name
                  })
                })) : undefined,
                onEdit: onEditSkill,
                onRemove: onRemoveSkill
              });
            }
          }), /*#__PURE__*/_jsx(Button, {
            icon: "edit",
            onClick: function onClick() {
              return setHasSkillPickerModal(true);
            },
            size: "medium",
            children: t('actions_select_skills')
          })]
        })
      }))]
    }), pendingSkillId && /*#__PURE__*/_jsx(UnsavedChangesModal, {
      canSaveChanges: false,
      onDiscardChanges: onDiscardChanges,
      onClose: function onClose() {
        return setPendingSkillId(null);
      }
    }), hasSkillPickerModal && /*#__PURE__*/_jsx(SkillPickerModal, {
      onClose: function onClose() {
        return setHasSkillPickerModal(false);
      },
      onSubmit: onSubmitSkills,
      defaultSelectedItems: skills
    })]
  });
}
export default SkillsField;